import React, { useEffect, useState } from 'react';
const START_SPOTS = 5;
const MIN_SPOTS = 3;
const STEP_MS = 90_000;
export function SpotsCounter() {
  const [spots, setSpots] = useState(START_SPOTS);
  useEffect(() => {
    if (spots <= MIN_SPOTS) return;
    const timer = window.setTimeout(() => {
      setSpots(prev => prev > MIN_SPOTS ? prev - 1 : prev);
    }, STEP_MS);
    return () => window.clearTimeout(timer);
  }, [spots]);
  return <p className="text-center text-[13px] font-bold uppercase tracking-[0.08em] text-ink" aria-live="polite" data-id="element-197" data-mp="9ui5u4cdzle5">
      <span aria-hidden="true" data-id="element-198" data-mp="dso7wz2a5csq">•</span> 20 spots at this price · Last{' '}
      <span className="text-star" data-id="element-199" data-mp="3vzls3hgu6mpb">{spots}</span> left <span aria-hidden="true" data-id="element-200" data-mp="4u3tia3r5pab">•</span>
    </p>;
}